import { Component } from '@angular/core';

@Component({
    selector: 'app-top-nav-notification',
    templateUrl: './top-nav-notification.component.html',
    styleUrls: ['./top-nav-notification.component.css']
})
/** top-nav-notification component*/
export class TopNavNotificationComponent {
    /** top-nav-notification ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/app/ui-components/top-nav-notification/top-nav-notification.component.ts